import React, { useState } from "react";
import { useTranslate, useDataProvider } from "react-admin";
import { withStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { AuthLayout } from "../components/layout/AuthLayout";
import styles from "./ResetPassword.module.scss";

export const ResetPassword = () => {
	const [newPassword, setNewPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [submitted, setSubmitted] = useState(false);
	const [success, setSuccess] = useState(true);
	const [redirectUrl, setRedirectUrl] = useState("#/login");
	const dataProvider = useDataProvider();
	const translate = useTranslate();
	const submit = (e) => {
		e.preventDefault();
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const resetToken = urlParams.get("reset_password_token");
		const redirectUrlParam = urlParams.get("redirect_url");
		if (newPassword !== confirmPassword) {
			setSuccess(false);
			setSubmitted(true);
		} else {
			dataProvider
				.resetPassword({ newPassword, confirmPassword, resetToken })
				.then((response) => {
					if (response.data) {
						if (redirectUrlParam) {
							setRedirectUrl(redirectUrlParam);
						}
						setSuccess(true);
						setSubmitted(true);
					}
				})
				.catch((error) => {
					setSuccess(false);
					setSubmitted(true);
				});
		}
	};

	const StyledButton = withStyles({
		root: {
			marginTop: "1em !important",
			background: "#417ec7 !important",
			color: "white !important",
			"&:hover": {
				background: "#417ec799 !important",
			},
		},
	})(Button);

	return (
		<AuthLayout>
			{!submitted ? (
				<form className={styles.form} onSubmit={submit}>
					<TextField
						required
						type="password"
						className={styles.formInput}
						id="newPassword"
						label={translate("resources.update_password.fields.new_password")}
						value={newPassword}
						onChange={(e) => setNewPassword(e.target.value)}
					/>
					<TextField
						required
						type="password"
						className={styles.formInput}
						id="confirmPassword"
						label={translate(
							"resources.update_password.fields.new_password_confirmation",
						)}
						value={confirmPassword}
						onChange={(e) => setConfirmPassword(e.target.value)}
					/>
					<StyledButton type="submit" className={styles.submitButton}>
						{translate("pos.login.reset_password_submit")}
					</StyledButton>
				</form>
			) : (
				<>
					<div className={styles.resetSuccess}>
						{success
							? translate("pos.login.reset_password_success")
							: translate("resources.update_password.notifications.error")}
					</div>
					<a
						href={decodeURIComponent(redirectUrl)}
						className={styles.submitButton}
					>
						{translate("pos.login.redirect_to_login")}
					</a>
				</>
			)}
		</AuthLayout>
	);
};
